var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Union_1","data-name":"Union 1","d":"M0,14V12H32v2ZM0,8V6H80V8ZM0,2V0H80V2Z","fill":"#0f0f0f"}));
}

Hamburger.defaultProps = {"id":"hamburger_icon","data-name":"hamburger icon","width":"80","height":"14","viewBox":"0 0 80 14"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
